"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddToBag = void 0;
var _reactHookForm = require("react-hook-form");
var _hooks = require("../../../../hooks");
var _BuyButton = require("../../../BuyButton");
var _context = require("../../context");
var _types = require("../../types");
var _jsxRuntime = require("react/jsx-runtime");
const AddToBag = ({
  onAddToBagClick
}) => {
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    analyticsData,
    itemCode
  } = (0, _context.useSubscriptionModule)();
  const {
    formState: {
      disabled: formStateDisabled,
      isSubmitting
    },
    watch
  } = (0, _reactHookForm.useFormContext)();
  const mode = watch('mode');
  const isSubscribeMode = mode === _types.SubscriptionModuleMode.Subscribe;
  const disabled = formStateDisabled || isSubmitting;
  const loading = isSubmitting;
  if (formStateDisabled) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_BuyButton.BuyButton, {
    buyTitle: translations.addToBag,
    disabled: disabled,
    disabledQuantity: isSubscribeMode,
    formattedPrice: analyticsData.formattedPrice,
    loading: loading,
    maxValue: isSubscribeMode ? 1 : undefined,
    onlyButton: isSubscribeMode,
    placement: analyticsData.placement,
    productCode: itemCode,
    productName: analyticsData.localName,
    reserveTitle: "",
    onClick: onAddToBagClick
  });
};
exports.AddToBag = AddToBag;
//# sourceMappingURL=AddToBag.js.map